import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { PassagensCadastroComponent } from './passagens-cadastro/passagens-cadastro.component';
import { PassagensFiltroComponent } from './passagens-filtro/passagens-filtro.component';
import { PassagensListaComponent } from './passagens-lista/passagens-lista.component';
import { PassagensService } from './passagens-service/passagens.service';
import { PassagensComponent } from './passagens.component';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    PassagensComponent
  ],
  declarations: [
    PassagensComponent,
    PassagensCadastroComponent,
    PassagensFiltroComponent,
    PassagensListaComponent
  ],
  providers: [
    PassagensService
  ]
})
export class PassagensModule { }
